import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MartAccess.css";

export default function MartAccess() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const val = e.target.elements.passkey.value;
    
    if (val === "marsmate@2026-contact-1234") {
      sessionStorage.setItem("marsMartUnlocked", "true");
      navigate("/mars-mart/home");
    } else {
      setError("Incorrect passkey. Please try again.");
      e.target.elements.passkey.value = "";
    }
  };

  return (
    <div className="mart-access-container">
      <div className="mart-access-card">
        <div className="mart-access-header">
          <h1 className="mart-access-title">🛒 MarsMart Store Access</h1>
          <p className="mart-access-subtitle">Exclusive Demo Store</p>
        </div>

        <p className="mart-access-description">
          Enter the passkey to access the MarsMart demo store.
        </p>

        <form onSubmit={handleSubmit} className="mart-access-form">
          <div className="form-group">
            <input
              name="passkey"
              type="password"
              placeholder="Enter passkey"
              className="mart-access-input"
              required
              autoFocus
            />
          </div>

          {error && <p className="mart-access-error">{error}</p>}

          <button type="submit" className="mart-access-btn">
            Access Store
          </button>
        </form>

        <div className="mart-access-footer">
          <button
            type="button"
            className="mart-access-back-btn"
            onClick={() => navigate(-1)}
          >
            ← Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
